import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PencilSquareIcon } from '@heroicons/react/24/outline';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Button, SmartTableCellProps } from '@/components/ui/daisy';
import StudentExam from '@/models/StudentExam';
import { ROUTES } from '@/utils/routes';

export default function ExamCorrectActionCell({
  item,
}: SmartTableCellProps<Pick<StudentExam, 'id' | 'klassId' | 'finishedAt'>>) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pendencies.exams',
  });

  const correctButton = (
    <Button
      size="sm"
      color="warning"
      variant="soft"
      disabled={!item.finishedAt}
    >
      <PencilSquareIcon className="w-4" />
      {t('correct')}
    </Button>
  );

  return (
    <ConditionalRenderer condition={!!item.finishedAt} fallback={correctButton}>
      <Link to={ROUTES.EXAM_CORRECTION.PROGRESS(item.klassId, item.id)}>
        {correctButton}
      </Link>
    </ConditionalRenderer>
  );
}
